import { ServiceBaySchedule } from "../../../../../../models/serviceBay";
import { useIntl } from "react-intl";

import "./styles.css";

interface ISchedulingCardProps {
  serviceBaySchedule: ServiceBaySchedule;
  openScheduleModal: () => void;
  showScheduleDate: boolean;
  atPoint?: 'start' | 'end' | 'allDay';
}

const SchedulingCard = (props: ISchedulingCardProps) => {
  const intl = useIntl();
  const scheduleHours = (): number => {
    if(props.atPoint === 'allDay') return 24;
    if(props.atPoint === 'end') return props.serviceBaySchedule.endDate!.getHours();
    
    const workdayEnd = new Date(props.serviceBaySchedule.startDate!);
    workdayEnd.setHours(24, 0, 0, 0);
    const hoursUntilEndOfDay = Math.ceil((workdayEnd.getTime() - props.serviceBaySchedule.startDate!.getTime()) / (1000 * 60 * 60));
    const scheduledHours = Math.ceil((props.serviceBaySchedule.endDate!.getTime() - props.serviceBaySchedule.startDate!.getTime()) / (1000 * 60 * 60));
    return Math.min(hoursUntilEndOfDay, scheduledHours) < 1 ? 1 : Math.min(hoursUntilEndOfDay, scheduledHours);
  }

  return (
    <div className="padding-x-3 height-100pct">
      <div
        className={`container width-100pct position-relative rounded border-2 display-flex align-items-center cursor-pointer ${props.serviceBaySchedule.occurrence?.finished ? 'bg-green-50 dark:bg-green-950 border-color-success' : 'bg-highlight-lightest border-color-highlight'}`}
        style={{
          height: `${scheduleHours() * 102}%`
        }}
        onClick={() => props.openScheduleModal()}
      >
        <div className="text-size-10 width-100pct">
          <div className={`text-bold padding-bottom-5 text-capitalize truncate text-color-highlight-dark}`}>
            {props.serviceBaySchedule.occurrence?.vehicleModel || props.serviceBaySchedule.occurrence?.vehicleName || ''}
          </div>
          <div className="display-grid grid-cols-2-1fr-max-content truncate">
            {props.showScheduleDate && <div className="truncate">
              {
                props.serviceBaySchedule.startDate?.toLocaleDateString(intl.locale, {
                  day: '2-digit',
                  month: '2-digit',
                })
              }{' '}
              {
                props.serviceBaySchedule.startDate?.toLocaleTimeString(intl.locale, {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              }
              {' - '}
              {
                props.serviceBaySchedule.endDate?.toLocaleDateString(intl.locale, {
                  day: '2-digit',
                  month: '2-digit',
                })
              }{' '}
              { 
                props.serviceBaySchedule.endDate?.toLocaleTimeString(intl.locale, {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              }
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulingCard;
